import { CheckoutState, Group, Agreement } from './checkout.reducer';
import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { CheckoutService } from '../services/checkout.service';
import { ValueUnwrapper } from '@angular/core/src/change_detection/change_detection';

@Component({
  selector: 'checkout-summary-component',
  templateUrl: './checkout-summary.component.html',
  styleUrls: ['../../assets/css/bootstrap.min.css', '../../assets/sass/checkout.scss']
})
export class CheckoutSummaryComponent {
  
  objectKeys: any;

  constructor(
    private router: Router,
    private checkoutService: CheckoutService
  ) {
    this.objectKeys = Object.keys;

   }


  @Input()
  checkout: CheckoutState;

  @Input()
  fillData = true;

  @Input()
  validCodes = {};

  goToCompanySelect() {
    this.checkoutService.setCheckout(this.checkout);
    this.router.navigateByUrl('/checkout/company');
  }

  isAnySubgroupActive(group: Group) {
    let anySelected = false;

    group.subgroups.forEach(subgrup => {
      if (subgrup.options.filter(o => o.checked).length > 0) {
        anySelected = true;
      }
    });

    return anySelected;
  }

  getTotalDiscountValue() {
    const totalWithoutDiscounts = this.getTotalAmount(true);
    const totalWithDiscounts = this.getTotalAmount();
    if(totalWithDiscounts == totalWithoutDiscounts){
      return false;
    }
    return (totalWithoutDiscounts-totalWithDiscounts).toFixed(2);
  }

  getTotalAmount(withoutDiscounts = false) {
    let total = this.checkout.line.netto;
    if(!withoutDiscounts){
      total = this.afterPromotionValue(total, 1, null, true);
    }
    this.checkout.line.groups.forEach(group => {
      group.subgroups.forEach(subgroup => {
        subgroup.options.forEach(option => {
          if (!option.checked) {
            return;
          }
          let value = 0.00;
          let promotion = null;

          if(!withoutDiscounts){
            if (this.validCodes) {
              for (let codeName in this.validCodes) {
                if (this.validCodes[codeName].target && this.validCodes[codeName].target == option.service) {
                  promotion = this.validCodes[codeName];
                }
              }
            }
          }
          if (option.type !== 'select') {
            const counter = option.selectedValue || 1;
            value = this.promotionRecalc(option.netto, counter, promotion, option);
          } else if (option.type === 'select') {
            value = this.promotionRecalc(option.range[option.selectedValue] as any, 1, promotion, option);
          }
          if(value){
            total += value;
          }
        });
      });
    });
    if(this.objectKeys(this.validCodes).length){
      for(const codeName in this.validCodes ){
        if(!this.validCodes[codeName].target && !withoutDiscounts){
          return this.promotionRecalc(total, 1, this.validCodes[codeName]);
        }
      }
    }
    return total;
  }

  haveServerPromotion() {
    if(this.validCodes){
      for(let codeName in this.validCodes){
        if(this.validCodes[codeName].target_type == 'server'){
          return true;
        }
      }
    }
    return false;
  }

  havePromotion(option) {
    if (this.validCodes) {
      for (let codeName in this.validCodes) {
        if (this.validCodes[codeName].target == option.service && option.service) {
          return true;
        }
      }
    }
    return false;
  }

  afterPromotionValue(value, counter, serviceId, isServerPromotion) {
    if (this.validCodes) {
      for (let codeName in this.validCodes) {
        if(isServerPromotion && this.validCodes[codeName].target_type == 'server'){
          return this.promotionRecalc(value, 1, this.validCodes[codeName]);
        }
        if (serviceId && this.validCodes[codeName].target == serviceId) {
          return this.promotionRecalc(value, counter, this.validCodes[codeName]);
        }
      }
    }
    return value * counter;
  }

  promotionRecalc(value, counter, promotion, option = {}) {
    if (promotion) {
      if (promotion.type == 1) {
        return (value - promotion.value) * counter;
      }
      if (promotion.type == 2) {
        return ((value - (value * (promotion.value / 100))) * counter);
      }
    }
    return value * counter;
  }

  getAgreement() {
    let selectedAgreement: Agreement = null;

    this.checkout.line.agreements.forEach(agreement => {
      if (agreement.checked) {
        selectedAgreement = agreement;
      }
    });
    if(selectedAgreement.name == 'Czas nieokreślony'){
      return 'Umowa na czas nieokreślony';
    }
    if(!selectedAgreement.name.match(/\d{1,2} miesi(ęcy|ące)/)){
      return selectedAgreement.name;
    }
    return "Umowa na " + selectedAgreement.name;
  }
}



// WEBPACK FOOTER //
// ./src/app/checkout/checkout-summary.component.ts